import contractTypeCreateComponent from './contract_type.create.component';

let contractTypeCreateModule = angular.module('contractTypeCreate', [])

    .component('contractTypeCreate', contractTypeCreateComponent)

    .name;

export default contractTypeCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract_type/create/index.js